// extracted by mini-css-extract-plugin
export var divider = "UserNavItem-module--divider--a1fac";
export var icon = "UserNavItem-module--icon--be391";
export var userEmail = "UserNavItem-module--userEmail--a47d1";
export var wrapper = "UserNavItem-module--wrapper--7e8cb";